module.exports = __webpack_public_path__ + "img/next-arrow.030d1702.svg";